import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getNotificationSettings(companyId: string) {
  const res = await apiFetch(
    `${API_URL}/notification-settings?companyId=${encodeURIComponent(companyId)}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać ustawień powiadomień.")
    );
  }

  return res.json();
}

export async function updateNotificationSettings(
  companyId: string,
  payload: {
    emailNotification: boolean;
    notifyUnconfirmedDocuments: boolean;
    dayToNotifyUnconfirmedDocs: number;
    unprocessedDaysToNotify: number;
  }
) {
  try {
    const res = await apiFetch(
      `${API_URL}/notification-settings?companyId=${encodeURIComponent(companyId)}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się zaktualizować ustawień powiadomień.")
      );
    }

    return res.json().catch(() => null);
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się zaktualizować ustawień powiadomień");
  }
}